import { useTranslation } from 'react-i18next'

export const getDefaultGroup = () => {
  const { t } = useTranslation()

  return {
    name: t('filters.participantGroup.allParticipant'),
    id: '0',
    defaultSegment: true,
  }
}
